import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getDatabase } from 'firebase/database'
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
  apiKey: 'AIzaSyD6vaiFTgBaFKW8rH_PvKzGTYiMNCL2dT8',
  authDomain: 'stadium-data.firebaseapp.com',
  databaseURL: 'https://stadium-data.firebaseio.com',
  projectId: 'stadium-data',
  storageBucket: 'stadium-data.appspot.com',
  messagingSenderId: '360504160008'
}

const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)
export const database = getDatabase(app)
export const storage = getStorage(app)
